import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";
// ****************************************** TabUnEnrollmentList ************************************************
export const getTabUnEnrollmentList = async (data) => {
  return decryptData(
    await axios.get(
      `/tab-unenrollment-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const UnEnrolltab = async (data) => {
  return decryptData(
    await axios.post(`/unenroll-tab`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
// ****************************************** UnEnrolledTabsList ************************************************
export const getUnenrolledlist = async (data) => {
  return decryptData(
    await axios.get(
      `/unenrolled-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
// ****************************************** UserAllowedCountries ************************************************
export const getUserAllowedCountriesList= async (data) => {
  return decryptData(
    await axios.get(
      `/userallowedcountries-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const AddUserAllowedCountry = async (data) => {
  return decryptData(
    await axios.post(`/userallowedcountry-create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const UpdateUserAllowedCountry = async (data) => {
  return decryptData(
    await axios.post(`/userallowedcountry-edit`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const DeleteUserAllowedCountry = async (data) => {
  return decryptData(
    await axios.post(`/userallowedcountry-delete`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
// ****************************************** UnEnrolledTabsList ************************************************
export const getMasterCountrieslist = async (data) => {
  return decryptData(
    await axios.get(
      `/master-countries?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const AddMasterCountry = async (data) => {
  return decryptData(
    await axios.post(`/master-country-create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const DeleteMasterCountry = async (data) => {
  return decryptData(
    await axios.post(`/master-country-delete`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const bulkUnEnrollTabByExcel = async (data) => {
  return decryptData(
    await axios.post(`/bulk-unenroll-device`, data, setMultiPartHeader())
  );
};
// ****************************************** Master Country ************************************************
export const getCountrieslist = async (data) => {
  return decryptData(
    await axios.get(
      `/get-countries?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};